import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import slick from "slick-carousel";
import PerfectScrollbar from "perfect-scrollbar";

/* ==============================================
ヘッダーの部分
============================================== */
// export function servicesFunc() {
//   let servicesTop = $("#servicesTop").length;

//   if (servicesTop) {
//     // subNavHeightFunc();

//     subNavAccordionFuc();

//     subNavScrollFunc();

//     // function subNavHeightFunc() {
//     //   let subNavHeight = $(".subNav");
//     //   let headerHeight = $("#header").outerHeight();
//     //   subNavHeight.css("top", `${headerHeight}px`);

//     //   let setTimer = false;
//     //   $(window).on("resize", function () {
//     //     if (setTimer !== false) {
//     //       clearTimeout(setTimer);
//     //     }
//     //     setTimer = setTimeout(() => {
//     //       subNavHeightFunc();
//     //     }, 200);
//     //   });
//     // }

//     function subNavAccordionFuc() {
//       const servicesSubNavAccordionBtn = $("#servicesSubNav .accordionBtn");
//       const servicesSubNav = $("#servicesSubNavList a");
//       let resizecheck = $("#responsibleCheck").width();
//       let resizecheck2 = 0;

//       $(window).on("load resize", function () {
//         resizecheck = $("#responsibleCheck").width();
//         subNavAccordionMenuStart();
//         subNavCloseFunc();
//       });

//       //スマホのみサブナビをクリックでクローズさせる
//       function subNavCloseFunc() {
//         if (resizecheck == "2") {
//           servicesSubNav.on("click", subNavClickHandler);
//         } else if (resizecheck == "1") {
//           servicesSubNav.off("click", subNavClickHandler);
//         }
//       }
//       function subNavClickHandler() {
//         servicesSubNavAccordionBtn.next("dd").slideUp(500);
//         $("#servicesSubNav").removeClass("isNavOpen");
//         servicesSubNavAccordionBtn.removeClass("isOpen");
//       }
//       subNavCloseFunc();

//       servicesSubNavAccordionBtn.on("click", function () {
//         const subNav = $("#servicesSubNav");

//         if (resizecheck == "2") {
//           if ($(this).hasClass("isOpen")) {
//             $(this)
//               .next("dd")
//               .slideUp(500, function () {
//                 subNav.removeClass("isNavOpen");
//               });
//             $(this).removeClass("isOpen");
//           } else {
//             servicesSubNavAccordionBtn.next("dd").slideUp(500);
//             servicesSubNavAccordionBtn.removeClass("isOpen");
//             $(this).next("dd").slideDown(500);
//             $(this).addClass("isOpen");

//             subNav.addClass("isNavOpen");
//           }
//         }
//       });

//       var subNavAccordionMenuStart = function () {
//         let resizecheck = $("#responsibleCheck").width();
//         if (resizecheck == "2" && resizecheck != resizecheck2) {
//           servicesSubNavAccordionBtn.next("dd").css("display", "none");
//           resizecheck2 = 2;
//         } else if (resizecheck == "1" && resizecheck != resizecheck2) {
//           servicesSubNavAccordionBtn.removeClass("isOpen");
//           servicesSubNavAccordionBtn.next("dd").css("display", "block");
//           resizecheck2 = 1;
//         }
//       };
//       subNavAccordionMenuStart();
//     }

//     function subNavScrollFunc() {
//       // 今回の交差を監視する要素
//       const boxes = document.querySelectorAll(".servicesList .list");

//       const options = {
//         root: null,
//         rootMargin: "0% 0px -87%",
//         threshold: 0,
//       };
//       const observer = new IntersectionObserver(doWhenIntersect, options);
//       boxes.forEach((box) => {
//         observer.observe(box);
//       });

//       /**
//        * 交差したときに呼び出す関数
//        * @param entries
//        */
//       function doWhenIntersect(entries) {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             activateIndex(entry.target);
//           }
//         });
//       }
//       /**
//        * 目次を変える関数
//        * @param element
//        */
//       function activateIndex(element) {
//         const currentActiveIndex = document.querySelector("#servicesSubNavList .active");
//         if (currentActiveIndex !== null) {
//           currentActiveIndex.classList.remove("active");
//         }
//         const newActiveIndex = document.querySelector(`a[href='#${element.id}']`).parentElement;
//         newActiveIndex.classList.add("active");

//         const currentTxt = document.querySelector(`a[href='#${element.id}']`).textContent;
//         $("#navCurrent").text(currentTxt).css({ color: "#fff" });
//       }
//     }

//     $(window).on("load scroll", function () {
//       var subNavCurrent = $("#servicesSubNavList .pageLinkList");
//       var scroll = $(window).scrollTop();
//       if (scroll == 0) {
//         $("#navCurrent").text("TENGA 20th Anniversary").css({ color: "#fff" });
//         if (subNavCurrent.hasClass("active")) {
//           subNavCurrent.removeClass("active");
//         }
//       }
//     });
//   }
// }

export function animation() {
  /* =============================================
gsap
============================================= */
  window.addEventListener("DOMContentLoaded", function () {
    let hasPlayed = false; // アニメーション実行済みフラグ
    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.matchMedia({
      // fv
      // PC用
      "(min-width: 768px)": function () {
        if (hasPlayed) return;
        hasPlayed = true;

        let tl = gsap.timeline();

        tl.fromTo(".fvBg", { autoAlpha: 0 }, { autoAlpha: 1, ease: "none", duration: 1 }).fromTo(".fvChara.first", { autoAlpha: 0, x: -400, y: 600 }, { autoAlpha: 1, x: 0, y: 0, ease: "power1.inOut", stagger: 0.4, duration: 0.4 }).fromTo(".fvChara.second", { autoAlpha: 0, x: 400, y: 600 }, { autoAlpha: 1, x: 0, y: 0, ease: "power1.inOut", stagger: 0.4, duration: 0.4 }).fromTo(".fvProduct.first,.fvProduct.second", { autoAlpha: 0, y: -600 }, { autoAlpha: 1, y: 0, ease: "power1.inOut", stagger: 0.4 }, ">").fromTo(".fvLogo, .fvLogo2, .fvTxt", { autoAlpha: 0, y: 10 }, { autoAlpha: 1, y: 0, ease: "power1.inOut" }, "<1");
      },

      // SP用
      "(max-width: 767px)": function () {
        if (hasPlayed) return;
        hasPlayed = true;

        let tl = gsap.timeline();

        tl.fromTo(".fvBg", { autoAlpha: 0 }, { autoAlpha: 1, ease: "none", duration: 1 }).fromTo(".fvChara.first", { autoAlpha: 0, x: -200, y: 400 }, { autoAlpha: 1, x: 0, y: 0, ease: "power1.inOut", stagger: 0.4, duration: 0.4 }).fromTo(".fvChara.second", { autoAlpha: 0, x: 200, y: 400 }, { autoAlpha: 1, x: 0, y: 0, ease: "power1.inOut", stagger: 0.4, duration: 0.4 }).fromTo(".fvProduct.first,.fvProduct.second", { autoAlpha: 0, y: -300 }, { autoAlpha: 1, y: 0, ease: "power1.inOut", stagger: 0.4 }, ">").fromTo(".fvLogo, .fvLogo2, .fvTxt", { autoAlpha: 0, y: 10 }, { autoAlpha: 1, y: 0, ease: "power1.inOut" }, "<1");
      },
    });

    //替えベルト
    let textWrappersChange = document.querySelectorAll(".detailBottomHeadWrap");

    textWrappersChange.forEach((textWrapperChange) => {
      let en = textWrapperChange.querySelector(".detailBottomHeadEn");
      let ja = textWrapperChange.querySelector(".detailBottomHeadJa");

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: textWrapperChange,
          start: "top 55%",
          // markers: true,
        },
      });
      tl.to(textWrapperChange, { "--scaleX": 1, duration: 0.5, ease: "power2.out" }).to(en, { autoAlpha: 1, y: 0, duration: 0.5 }).to(ja, { autoAlpha: 1, y: 0, duration: 0.5 }, "<");
    });

    //機能紹介
    let textWrappersSpec = document.querySelectorAll(".specHeadWrap");

    textWrappersSpec.forEach((textWrapperSpec) => {
      let en = textWrapperSpec.querySelector(".specHeadEn");
      let ja = textWrapperSpec.querySelector(".specHeadJa");

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: textWrapperSpec,
          start: "top 55%",
          // markers: true,
        },
      });
      tl.to(textWrapperSpec, { "--scaleX": 1, duration: 0.5, ease: "power2.out" }).to(en, { autoAlpha: 1, y: 0, duration: 0.5 }).to(ja, { autoAlpha: 1, y: 0, duration: 0.5 }, "<");

      // --- .fadeIn の処理 ---
      gsap.utils.toArray(".fadeIn").forEach((target) => {
        gsap.fromTo(
          target,
          { autoAlpha: 0 },
          {
            autoAlpha: 1,
            scrollTrigger: {
              trigger: target,
              start: "top 80%",
            },
          },
        );
      });
    });

    // fvの見出しのライン
    function updateBallLocationFv() {
      const width = window.innerWidth;
      let ballLocation;

      if (width < 768) {
        ballLocation = "-2vw"; // SP
      } else if (width < 1440) {
        ballLocation = "38vw"; // タブレット〜中間
      } else {
        ballLocation = "520px"; // PC
      }
      const speciaHeadTL = gsap.timeline({
        scrollTrigger: {
          trigger: ".fvBottomRight",
          start: "top 70%",
        },
      });
      speciaHeadTL.to(".fvBottomRightTitWrap", { "--scaleX": 1, duration: 1, ease: "power2.out" }).to(".fvBottomRightTit", { autoAlpha: 1, duration: 0.5 });
    }

    // 製品情報
    function updateBallLocationDetail() {
      const width = window.innerWidth;
      let ballLocation;

      if (width < 768) {
        ballLocation = "0vw"; // SP
      } else if (width < 1440) {
        ballLocation = "38vw"; // タブレット〜中間
      } else {
        ballLocation = "520px"; // PC
      }
      const speciaHeadTL = gsap.timeline({
        scrollTrigger: {
          trigger: ".detailHeadWrap",
          start: "top 70%",
        },
      });
      speciaHeadTL.to(".detailHeadWrap", { "--scaleX": 1, duration: 1, ease: "power2.out" }).to(".detailHeadBall", { "--ball-location": ballLocation, "--ball-rotation": "-720deg", duration: 1.5 }, "<").to(".detailHeadEn", { autoAlpha: 1, duration: 0.5 }).to(".detailHeadJa", { autoAlpha: 1, y: 0, duration: 0.5 }, "<");
    }

    // 専用ボックス
    function updateBallLocationSpecial() {
      const width = window.innerWidth;
      let ballLocation;

      if (width < 768) {
        ballLocation = "76vw"; // SP
      } else if (width < 1440) {
        ballLocation = "51vw"; // タブレット〜中間
      } else {
        ballLocation = "720px"; // PC
      }
      const specialHeadTL = gsap.timeline({
        scrollTrigger: {
          trigger: ".specialHeadWrap",
          start: "top 70%",
        },
      });
      specialHeadTL.to(".specialHeadWrap", { "--scaleX": 1, duration: 1, ease: "power2.out" }).to(".specialHeadBall", { "--ball-location": ballLocation, "--ball-rotation": "720deg", duration: 2 }, "<").to(".specialHeadEn", { autoAlpha: 1, duration: 0.5 }).to(".specialHeadJa", { autoAlpha: 1, y: 0, duration: 0.5 }, "<");
    }

    // OTHER MODEL
    function updateBallLocationOtherModel() {
      const width = window.innerWidth;
      let ballLocation;

      if (width < 768) {
        ballLocation = "78vw"; // SP
      } else if (width < 1440) {
        ballLocation = "56vw"; // タブレット〜中間
      } else {
        ballLocation = "800px"; // PC
      }
      const otherHeadTL = gsap.timeline({
        scrollTrigger: {
          trigger: ".otherModelHeadWrap",
          start: "top 70%",
        },
      });
      otherHeadTL.to(".otherModelHeadWrap", { "--scaleX": 1, duration: 1, ease: "power2.out" }).to(".otherModelHeadBall", { "--ball-location": ballLocation, "--ball-rotation": "720deg", duration: 2 }, "<").to(".otherModelHeadEn", { autoAlpha: 1, duration: 0.5 }).to(".otherModelHeadJa", { autoAlpha: 1, y: 0, duration: 0.5 }, "<");
    }

    window.addEventListener("resize", () => {
      updateBallLocationFv();
      updateBallLocationDetail();
      updateBallLocationSpecial();
      updateBallLocationOtherModel();
    });
    updateBallLocationFv();
    updateBallLocationDetail();
    updateBallLocationSpecial();
    updateBallLocationOtherModel();
    // let textWrappersSpecial = document.querySelectorAll(".specialHeadWrap");
    // textWrappersSpecial.forEach((textWrapperSpecial) => {
    //   let en = textWrapperSpecial.querySelector(".specialHeadEn");
    //   let ja = textWrapperSpecial.querySelector(".specialHeadJa");

    //   const width = window.innerWidth;
    //   let ballLocation;
    //   if (width < 768) {
    //     ballLocation = "-4vw"; // SP
    //   } else if (width < 1440) {
    //     ballLocation = "-3vw"; // タブレット〜中間
    //   } else {
    //     ballLocation = "0px";
    //   }

    //   let tl = gsap.timeline({
    //     scrollTrigger: {
    //       trigger: textWrapperSpecial,
    //       start: "top 55%",
    //       // markers: true,
    //     },
    //   });
    //   tl
    //   .to(textWrapperSpecial, { "--scaleX": 1, duration: 1, ease: "power2.out" })
    //   .to(en, {"--ball-location": "1.3vw","--ball-rotation": "360deg"})
    //   // .to(en, { autoAlpha: 1, y: 0, duration: 0.5 })
    //   .to(ja, { autoAlpha: 1, y: 0, duration: 0.5 }, "<");

    // });

    // 商品ラインナップ（PC）
    document.querySelectorAll(".productItemLink").forEach((item) => {
      const img = item.querySelector(".productItemImg");
      const text = item.querySelector(".productItemTxtWrap");

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: "top 20%",
          toggleActions: "play none none none",
        },
      });

      tl.fromTo(img, { autoAlpha: 0, y: -200 }, { autoAlpha: 1, y: 0, ease: "power1.inOut", duration: 0.6 }).fromTo(text, { autoAlpha: 0, y: 200 }, { autoAlpha: 1, y: 0, ease: "power1.inOut", duration: 0.6 }, "<");
    });

    // 商品ラインナップ（SP）
    document.querySelectorAll(".productItemLinkSp").forEach((item) => {
      const img = item.querySelector(".productItemImgSp");
      const text = item.querySelector(".productItemTxtWrapSp");

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: "top 60%",
          toggleActions: "play none none none",
        },
      });

      tl.fromTo(img, { autoAlpha: 0, y: -200 }, { autoAlpha: 1, y: 0, ease: "power1.inOut", duration: 0.6 }).fromTo(
        text,
        { autoAlpha: 0, y: 200 },
        { autoAlpha: 1, y: 0, ease: "power1.inOut", duration: 0.6 },
        "<", // 同時開始にするならここに "<"
      );
    });

     // 商品ラインナップセカンドモデル（PC）
    document.querySelectorAll(".productSecondItemLink").forEach((item) => {
      const img = item.querySelector(".productItemSecondImg");
      const text = item.querySelector(".productSecondItemTxtWrap");

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: "top 20%",
          toggleActions: "play none none none",
        },
      });

      tl.fromTo(img, { autoAlpha: 0}, { autoAlpha: 1,ease: "power1.inOut", duration: 0.6 }).fromTo(text, { autoAlpha: 0, y: 200 }, { autoAlpha: 1, y: 0, ease: "power1.inOut", duration: 0.6 }, "<");
    });

    // 商品ラインナップセカンドモデル（SP）
    document.querySelectorAll(".productSecondItemLinkSp").forEach((item) => {
      const img = item.querySelector(".productSecondItemImgSp");
      const text = item.querySelector(".productSecondItemTxtWrapSp");

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: "top 60%",
          toggleActions: "play none none none",
        },
      });

      tl.fromTo(img, { autoAlpha: 0}, { autoAlpha: 1, ease: "power1.inOut", duration: 0.6 }).fromTo(
        text,
        { autoAlpha: 0, y: 200 },
        { autoAlpha: 1, y: 0, ease: "power1.inOut", duration: 0.6 },
        "<", // 同時開始にするならここに "<"
      );
    });

    // 製品情報の画像スライド
    const detailKarasunoProductImTL = gsap.timeline({
      scrollTrigger: {
        trigger: ".detailKarasunoBottomImgWrap",
        start: "top 70%",
      },
    });

    detailKarasunoProductImTL.to(".detailKarasunoBottomImg", { "--clip-x": "0%", duration: 0.7 });

    const detailProductImTL = gsap.timeline({
      scrollTrigger: {
        trigger: ".detailNekomaBottomImgWrap",
        start: "top 70%",
      },
    });
    detailProductImTL.to(".detailNekomaBottomImg", { "--clip-x": "0%", duration: 0.7 });

    // 専用ボックス、帯
    const specialItem1TL = gsap.timeline({
      scrollTrigger: {
        trigger: ".specialItem.first",
        start: "top 70%",
      },
    });
    specialItem1TL.to(".specialItem.first", { "--clip-x": "0%", duration: 0.8 }).to(".specialItemTit.first", { clipPath: "inset(0 0% 0 0)", duration: 1.3 }, "<").fromTo(".specialItemImg.first", { autoAlpha: 0 }, { autoAlpha: 1 }).fromTo(".specialItemChara.first", { autoAlpha: 0, x: -100, y: 100 }, { autoAlpha: 1, x: 0, y: 0, duration: 0.3 }, "<");

    const specialItem2TL = gsap.timeline({
      scrollTrigger: {
        trigger: ".specialItem.second",
        start: "top 70%",
      },
    });
    specialItem1TL.to(".specialItem.second", { "--clip-x": "0%", duration: 0.8 }).to(".specialItemTit.second", { clipPath: "inset(0 0% 0 0)", duration: 1.3 }, "<").fromTo(".specialItemImg.second", { autoAlpha: 0 }, { autoAlpha: 1 }).fromTo(".specialItemChara.second", { autoAlpha: 0, x: 100, y: 100 }, { autoAlpha: 1, x: 0, y: 0, duration: 0.3 }, "<");
  });

  // 製品情報 キャラクター差し替え
  const karasunoNormal1 = document.querySelector(".detailKarasunoTopHeadChara.first:not(.active)");
  const karasunoActive1 = document.querySelector(".detailKarasunoTopHeadChara.first.active");

  const karasunoNormal2 = document.querySelector(".detailKarasunoTopHeadChara.second:not(.active)");
  const karasunoActive2 = document.querySelector(".detailKarasunoTopHeadChara.second.active");

  const karasunoNormal3 = document.querySelector(".detailKarasunoTopHeadChara.third:not(.active)");
  const karasunoActive3 = document.querySelector(".detailKarasunoTopHeadChara.third.active");

  const nekomaNormal1 = document.querySelector(".detailNekomaTopHeadChara.first:not(.active)");
  const nekomaActive1 = document.querySelector(".detailNekomaTopHeadChara.first.active");

  const nekomaNormal2 = document.querySelector(".detailNekomaTopHeadChara.second:not(.active)");
  const nekomaActive2 = document.querySelector(".detailNekomaTopHeadChara.second.active");

  const nekomaNormal3 = document.querySelector(".detailNekomaTopHeadChara.third:not(.active)");
  const nekomaActive3 = document.querySelector(".detailNekomaTopHeadChara.third.active");

  // 各キャラのスライド開始X座標
  const fromXMap = {
    first: 200,
    second: -200,
    third: 200,
  };

  function showGroup(chars, onComplete) {
    // まず全員初期位置＆非表示にセット
    chars.forEach(({ element, fromX }) => {
      gsap.set(element, { x: fromX, opacity: 0 });
    });

    // まとめてスライドイン＆フェードイン（同時）
    gsap.to(
      chars.map((c) => c.element),
      {
        duration: 0.3,
        x: 0,
        opacity: 1,
        ease: "power2.out",
        onComplete: () => {
          // 2秒表示後にまとめてフェードアウト
          gsap.to(
            chars.map((c) => c.element),
            {
              delay: 2,
              duration: 0.3,
              opacity: 0,
              ease: "power2.out",
              onComplete,
            },
          );
        },
      },
    );
  }

  function loopImages() {
    const normalChars = [
      { element: karasunoNormal1, fromX: fromXMap.first },
      { element: karasunoNormal2, fromX: fromXMap.second },
      { element: karasunoNormal3, fromX: fromXMap.third },
      { element: nekomaNormal1, fromX: fromXMap.first },
      { element: nekomaNormal2, fromX: fromXMap.second },
      { element: nekomaNormal3, fromX: fromXMap.third },
    ];

    const activeChars = [
      { element: karasunoActive1, fromX: fromXMap.first },
      { element: karasunoActive2, fromX: fromXMap.second },
      { element: karasunoActive3, fromX: fromXMap.third },
      { element: nekomaActive1, fromX: fromXMap.first },
      { element: nekomaActive2, fromX: fromXMap.second },
      { element: nekomaActive3, fromX: fromXMap.third },
    ];

    showGroup(normalChars, () => {
      showGroup(activeChars, () => {
        loopImages();
      });
    });
  }

  // 最初にすべて非表示に
  gsap.set([karasunoNormal1, karasunoActive1, karasunoNormal2, karasunoActive2, karasunoNormal3, karasunoActive3, nekomaNormal1, nekomaActive1, nekomaNormal2, nekomaActive2, nekomaNormal3, nekomaActive3], { opacity: 0 });

  loopImages();
}

export function slide() {
  /* =============================================
slick
============================================= */
  // let indexPage = $("#indexTop").length;
  // let resizecheck = $("#responsibleCheck").width();
  // $(window).on("resize", function () {
  //   resizecheck = $("#responsibleCheck").width();
  // });
  // console.log($(".slideArea").hasClass("slick-initialized")); // trueなら動作中
  // if (indexPage) {
  //   var slideStart = function () {
  //     $(".slideArea").each(function (i) {
  //       var $_t = $(this);
  //       let slideClass = $_t.addClass("slide" + i);
  //       //スライダー部分
  //       if (resizecheck <= 1) {
  //         $(".slideArea.slick-initialized").slick("unslick");
  //       } else {
  //         //スライダー部分
  //         slideClass.not(".slick-initialized").slick({
  //           autoplay: true,
  //           autoplaySpeed: 5000,
  //           speed: 400,
  //           slidesToShow: 2,
  //           // variableWidth: true,
  //           centerMode: true,
  //           arrows: true,
  //           dots: false,
  //           fade: false,
  //           infinite: true,
  //           pauseOnTouchMove: false,
  //           pauseOnHover: false,
  //           nextArrow: '<img src="/s/garrack/feature/onepiece2025/images/detail/slide_arrows_next.svg" class="slide-arrow next-arrow">',
  //           prevArrow: '<img src="/s/garrack/feature/onepiece2025/images/detail/slide_arrows_prev.svg" class="slide-arrow prev-arrow">',
  //         });
  //         // 追加：dotにクラス名を付与
  //         $_t.find(".slick-dots li").each(function (index) {
  //           $(this).addClass("dot-" + (index + 1));
  //         });
  //       }
  //     });
  //   };
  //   slideStart();
  //   let setTimer = false;
  //   $(window).on("resize", function () {
  //     if (setTimer !== false) {
  //       clearTimeout(setTimer);
  //     }
  //     setTimer = setTimeout(() => {
  //       slideStart();
  //     }, 200);
  //   });
  // }
  window.addEventListener("scroll", function () {
    const trigger = document.getElementById("js-floating-start");
    const triggerEnd = document.getElementById("js-floating-end");
    const fixContent = document.getElementById("fixedBtnWrap");
    const scrollValue = window.scrollY;
    const clientRect = trigger.getBoundingClientRect();
    const clientRectEnd = triggerEnd.getBoundingClientRect();
    const py = window.pageYOffset + clientRect.top - window.innerHeight;
    const ey = window.pageYOffset + clientRectEnd.top;
    if (py < scrollValue && ey > scrollValue + window.innerHeight) {
      fixContent.classList.add("is-show");
    } else {
      fixContent.classList.remove("is-show");
    }
  });
}
export function scrollBar() {
  window.addEventListener("load", function () {
    const targets = document.querySelectorAll(".detailKarasunoBottomMeterListWrap,.detailNekomaBottomMeterListWrap");

    const initScrollbar = () => {
      const isSP = window.innerWidth <= 767;

      targets.forEach((target) => {
        if (isSP) {
          // SP（767以下）のとき → PerfectScrollbar 有効化
          if (!target._ps) {
            target._ps = new PerfectScrollbar(target, {
              suppressScrollY: true, // 縦スクロール無効化
            });

            target.addEventListener("click", function () {
              target.classList.add("isActive");
              target._ps.update();
            });
          }
        } else {
          // PC（768以上）のとき → PerfectScrollbar 無効化
          if (target._ps) {
            target._ps.destroy();
            target._ps = null;
          }
        }
      });
    };

    // 初期化
    initScrollbar();

    // リサイズ対応
    window.addEventListener("resize", initScrollbar);
  });
}
